import { render, staticRenderFns } from "./DataCheckbox.vue?vue&type=template&id=73a6787e&scoped=true"
import script from "./DataCheckbox.vue?vue&type=script&lang=js"
export * from "./DataCheckbox.vue?vue&type=script&lang=js"
import style0 from "./DataCheckbox.vue?vue&type=style&index=0&id=73a6787e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6787e",
  null
  
)

export default component.exports